import * as ActionTypes from 'actions';
import has from 'lodash/has';
import forEach from 'lodash/forEach';

import Calendar from 'lib/Calendar';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  isLoading: false,
  selected: {},
  search: {},
};

function parseDetailedItem(item, key, subsection, parentId = false) {
  let detailedItem = {
    subsection: has(item, 'subsection') ? item.subsection : subsection,
    ...item,
    parentId,
    _key: key,
  };
  detailedItem.prefixedId = `${Calendar.determineIdPrefix(detailedItem.subsection)}${item.id}`;

  return detailedItem;
}

function parseDetailedItemChildren(section, subsection, state, parent) {
  let newState = { ...state };

  if (!has(newState, `${section}.${subsection}.${parent.prefixedId}.lines`)) {
    newState[section][subsection][parent.prefixedId] = { lines: [] };
  }

  forEach(parent.children, (item, key) => {
    const detailedItem = parseDetailedItem(item, key, subsection, parent.prefixedId);
    newState[section][subsection].all[detailedItem.prefixedId] = detailedItem;
    newState[section][subsection][parent.prefixedId].lines.push(detailedItem);

    if (has(item, 'children')) {
      newState = parseDetailedItemChildren(section, subsection, newState, detailedItem);
    }
  });
  return newState;
}

export default function(state = initialState, action = {}) {
  const { type, response, error, section, subsection } = action;

  switch (type) {
  case ActionTypes.SEARCH_DATA_REQUEST:
    return { ...state, isLoading: true };

  case ActionTypes.SEARCH_DATA_SUCCESS: {
    const newState = { ...state };
    const prefixedParentId = null;

    // @TODO need to determine if this response is for the current search term. If it's not, ignore it
    // console.info('DUDE, get_search_data', response);

    const subsections = action.subsections.split(',');

    if (!has(newState, `search.${section}`)) {
      newState.search[section] = {};
    }

    subsections.forEach((sub) => {
      if (!has(newState, `search.${section}.${sub}.root`)) {
        newState.search[section][sub] = { root: {}, all: {} };
      }

      if (has(response, `subsections.${sub}.lines`)) {
        const lines = [];

        forEach(response.subsections[sub].lines, (item, key) => {
          const detailedItem = parseDetailedItem(item, key, sub, prefixedParentId);
          newState.search[section][sub].all[detailedItem.prefixedId] = detailedItem;
          lines.push(detailedItem);

          if (has(item, 'children')) {
            newState.search = parseDetailedItemChildren(section, sub, newState.search, detailedItem);
          }
        });
        response.subsections[sub].lines = lines;
      }

      newState.search[section][sub].root = { ...response.subsections[sub] };
    });

    return { ...newState, isLoading: false };
  }

  case ActionTypes.SEARCH_DATA_FAILURE: {
    console.error('Error loading SEARCH_DATA', error);
    return { ...state, isLoading: false };
  }

  case ActionTypes.SUBSECTION_NUMBER_REQUEST:
    return { ...state, isLoading: true };

  case ActionTypes.SUBSECTION_NUMBER_SUCCESS: {
    let newState = { ...state };

    const prefixedParentId = null;

    newState[section] = newState[section] || {};
    newState[section][subsection] = newState[section][subsection] || { root: {}, all: {} };

    if (response.lines) {
      const lines = [];

      forEach(response.lines, (item, key) => {
        const detailedItem = parseDetailedItem(item, key, response.subsection, prefixedParentId);
        newState[section][subsection].all[detailedItem.prefixedId] = detailedItem;
        lines.push(detailedItem);

        if (has(item, 'children')) {
          newState = parseDetailedItemChildren(section, subsection, newState, detailedItem);
        }
      });
      response.lines = lines;
    }

    newState[section][subsection].root = { ...response };

    return { ...newState, isLoading: false };
  }

  case ActionTypes.SUBSECTION_NUMBER_FAILURE: {
    console.error('Error loading SUBSECTION_NUMBER', error);
    return { ...state, isLoading: false };
  }

  case ActionTypes.DATA_GROUP_REQUEST:
    return { ...state, isLoading: true };

  case ActionTypes.DATA_GROUP_SUCCESS: {
    let newState = { ...state };
    // const { total_objects, parent_ids, other_objects, inside_subsection, inside_id } = response;

    const prefixedParentId = action.parent_id ? `${Calendar.determineIdPrefix(subsection)}${action.parent_id}` : null;

    var lines_subsection = subsection;

    if(action.parent_id && response.inside_subsection) {
      if(response.inside_subsection == subsection && response.subsection != response.inside_subsection) lines_subsection = response.subsection;
    }

    newState[section] = newState[section] || {};
    newState[section][subsection] = newState[section][subsection] || { root: {}, all: {} };

    if (response.lines) {
      const lines = [];

      forEach(response.lines, (item, key) => {
        const detailedItem = parseDetailedItem(item, key, lines_subsection, prefixedParentId);
        newState[section][subsection].all[detailedItem.prefixedId] = detailedItem;
        lines.push(detailedItem);

        if (has(item, 'children')) {
          newState = parseDetailedItemChildren(section, subsection, newState, detailedItem);
        }
      });
      response.lines = lines;
    }

    if (action.parent_id) {
      newState[section][subsection][prefixedParentId] = { ...response };
    } else {
      newState[section][subsection].root = { ...response };
    }

    return { ...newState, isLoading: false };
  }

  case ActionTypes.DATA_GROUP_FAILURE: {
    console.error('Error loading DATA_GROUP', error);
    return { ...state, isLoading: false };
  }

  case ActionTypes.DATA_GROUP_ITEM_SELECTED: {
    const { payload } = action;
    const { section, subsection, item, prefixedParentId, displayType } = payload;
    const selected = { ...state.selected };

    const stateSection = (displayType == 'search') ? state.search : state;

    const isIdSelected = id => has(selected, `${section}.${subsection}.${id}`);

    const unselectMyChildren = (me) => {
      if (me.has_children && has(stateSection, `${section}.${subsection}.all`)) {
        forEach(stateSection[section][subsection].all, (value, key) => {
          if (value && value.parentId === me.prefixedId) {
            if (value.has_children) {
              unselectMyChildren(value);
            }
            if (isIdSelected(key)) {
              delete selected[section][subsection][key];
            }
          }
        });
      }
    };

    const detailedItem = parseDetailedItem(item, item.id, subsection, prefixedParentId);

    unselectMyChildren(detailedItem);

    selected[section] = selected[section] || {};
    selected[section][subsection] = selected[section][subsection] || {};

    selected[section][subsection][detailedItem.prefixedId] = detailedItem;

    return { ...state, selected };
  }

  case ActionTypes.DATA_GROUP_ITEM_UNSELECT: {
    const { payload } = action;
    const { section, subsection, item, prefixedParentId, displayType } = payload;
    const selected = { ...state.selected };
    
    const newState = (displayType == 'search') ? { ...state.search } : { ...state };

    const isIdSelected = id => has(selected, `${section}.${subsection}.${id}`);
    const removeId = (id) => {
      if (isIdSelected(id)) {
        delete selected[section][subsection][id];
        return true;
      } else {
        return false;
      }
    };

    const selectChildrenOfParent = (parentId) => {
      forEach(newState[section][subsection][parentId].lines, (item) => {
        selected[section][subsection][item.prefixedId] = { ...item, parentId };
      });
    };

    const selectOtherChildrenOfParent = (childId, parentId) => {
      forEach(newState[section][subsection][parentId].lines, (item) => {
        if(item.prefixedId != childId) {
          selected[section][subsection][item.prefixedId] = { ...item, parentId };
        }
      });
    };

    const selectToUnselectUpTree = (item) => {
      if (item.parentId && has(newState, `${section}.${subsection}.all.${item.parentId}`)) {
        selectChildrenOfParent(item.parentId);
        removeId(item.prefixedId);

        if (!isIdSelected(item.parentId)) {
          selectToUnselectUpTree(newState[section][subsection].all[item.parentId]);
        } else {
          removeId(item.parentId);
        }
      }
    };

    const detailedItem = parseDetailedItem(item, item.id, subsection, prefixedParentId);

    // Unselect parent if currently selected
    if (prefixedParentId && isIdSelected(prefixedParentId)) {
      removeId(prefixedParentId);

      // Manually select all of the children of that parent
      selectOtherChildrenOfParent(detailedItem.prefixedId, prefixedParentId);
    } else if (!removeId(detailedItem.prefixedId)) {
      // If I wasn't directly selected and neither was my parent then it has to be higher up the chain that is selected
      // We know this because if my direct parent was selected I would have been selected by previous step (and now unselected)
      selectToUnselectUpTree({ ...detailedItem, parentId: prefixedParentId });
    }

    return (displayType == 'search') ? { ...state, search: newState, selected } : { ...newState, selected };
  }

  case ActionTypes.DATA_GROUP_RESET_SEARCH: {
    const { payload } = action;
    const search = { ...state.search };

    search[payload.section] = {};

    return { ...state, search };
  }

  case ActionTypes.DATA_GROUP_RESET_SELECTED: {
    const { payload } = action;
    const selected = { ...state.selected };

    selected[payload.section] = {};

    return { ...state, selected };
  }

  case ActionTypes.DATA_GROUP_SET_SELECTED: {
    const { payload } = action;
    const selected = { ...state.selected };

    if (payload.defaultSelected) {
      selected[payload.section] = selected[payload.section] || {};
      selected[payload.section][payload.subsection] = selected[payload.section][payload.subsection] || {};

      forEach(payload.defaultSelected, (item, key) => {
        const detailedItem = parseDetailedItem(item, key, payload.subsection);
        selected[payload.section][payload.subsection][detailedItem.prefixedId] = detailedItem;
      });
    }

    return { ...state, selected };
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/eventDataGroups.js